export default __webpack_public_path__ + "static/media/grid-min.b3681ec1.png";